module.exports = __webpack_public_path__ + "static/media/DudFast.3a144aa6.wav";


//////////////////
// WEBPACK FOOTER
// ./src/Sounds/DudFast.wav
// module id = 67
// module chunks = 0